import { Stack } from "@mui/material";

import Nav from "./Nav/Index";
import Main from "./Main/Index";

export default function Index() {
  return (
    <Stack flexDirection={"row"} sx={{}}>
      <Stack
        flexDirection={"row"}
        component={"main"}
        sx={{ width: 1, minHeight: { lg: 1 } }}
      >
        <Nav />
        <Main />
      </Stack>
    </Stack>
  );
}
